/*
 * Application Insights JavaScript SDK - Common, 2.7.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
// THIS FILE WAS AUTOGENERATED

/**
 * Type of the metric data measurement.
 */
export var DataPointType;

(function (DataPointType) {
  DataPointType[DataPointType["Measurement"] = 0] = "Measurement";
  DataPointType[DataPointType["Aggregation"] = 1] = "Aggregation";
})(DataPointType || (DataPointType = {}));